import { useMemo } from 'react';

import { UseLogicQualitySingleCheckProvider } from 'components/widgets/LogicQualitySingleCheck/LogicQualitySingleCheck.provider';
import { initialStateHelper } from 'components/widgets/ValidationTable/ValidationTable.utils';

import { getValidationColumns, isWholeProject } from 'utilitys/logicQualityCheck.utils';

interface Props {
    ui: UseLogicQualitySingleCheckProvider['ui'];
    api: UseLogicQualitySingleCheckProvider['api'];
    check: string;
}

export const useLogicQualitySingleCheckLogic = ({ ui, api, check }: Props) => {
    const validationTypeDrillDown = api.validationTypeDrillDown.data;
    const validationOverview = validationTypeDrillDown?.validationDescription;
    const validation = api.logicCheckerConfiguration.data?.find((item) => item.validationName === check);
    const isLoadingTableData = api.validationTypeDrillDown.isLoading;

    const generatedCols = useMemo(() => {
        return getValidationColumns({
            validationTypeDrillDown,
            validation,
            check,
            versionHashCode: ui.vars.latestVersionHashCode,
        });
    }, [validationTypeDrillDown, check, validation]);

    const generatedData = useMemo(() => {
        return validationTypeDrillDown?.rows.filter(isWholeProject) || [];
    }, [validationTypeDrillDown]);

    const tableInitialState = useMemo(() => {
        return initialStateHelper({
            generatedCols,
            parsedCheck: check,
        });
    }, [generatedCols]);

    const wholeProjectRow = useMemo(() => {
        if (validationTypeDrillDown) {
            const row = validationTypeDrillDown?.rows?.at(-1);
            return row && !isWholeProject(row) ? row : undefined;
        }
    }, [validationTypeDrillDown]);

    return {
        logic: {
            generatedData,
            generatedCols,
            validation,
            tableInitialState,
            isLoadingTableData,
            validationOverview,
            wholeProjectRow,
        },
    };
};
